import React, { useEffect } from "react";
import CustomInput from "../components/CustomInput";
import Dropzone from "react-dropzone";
import { useFormik } from "formik";
import * as yup from "yup";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { uploadImg, delImg    } from "../features/upload/uploadSlice";
import {
  createClient,
  getAClient,
  updateAClient,
  resetState,
} from "../features/clients/clientSlice";

const schema = yup.object().shape({
  title: yup.string().required("Title is required"),
});

const AddClient = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const clientId = location.pathname.split("/")[3];

  const { images: imgState, isSuccess: imgSuccess } = useSelector((state) => state.upload);
  const clientState = useSelector((state) => state.clients);

  const {
    isSuccess,
    isError,
    isLoading,
    createdClient,
    updatedClient,
    clientTitle,
    clientImages = [],
  } = clientState;

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: clientTitle || "",
      images: clientImages || [],
    },
    validationSchema: schema,
    onSubmit: (values) => {
      if (clientId !== undefined) {
        dispatch(updateAClient({ id: clientId, clientData: values }));
      } else {
        dispatch(createClient(values));
      }

      formik.resetForm({
        values: {
          ...formik.initialValues,
          images: [],
        },
      });

      dispatch(resetState());
       
    },
  });

  useEffect(() => {
    if (clientId !== undefined) {
      dispatch(getAClient(clientId));
    } else {
      dispatch(resetState());
    }
  }, [clientId]);

  useEffect(() => {
    if (imgState.length > 0) {
      const formatted = imgState.map((i) => ({
        public_id: i.public_id,
        url: i.url,
      }));
      formik.setFieldValue("images", [...formik.values.images, ...formatted]);
    }
  }, [imgState]);

  useEffect(() => {
    if (isSuccess && createdClient) {
      toast.success("Client added successfully!");
      setTimeout(() => navigate("/admin/client-list"), 2000);
    }

    if (isSuccess && updatedClient) {
      toast.success("Client updated successfully!");
      setTimeout(() => navigate("/admin/client-list"), 2000);
    }

    if (isError) toast.error("Something went wrong!");
  }, [isSuccess, isError, createdClient, updatedClient]);

  const handleImageDelete = (public_id) => {
    dispatch(delImg(public_id));
    const filtered = formik.values.images.filter((img) => img.public_id !== public_id);
    formik.setFieldValue("images", filtered);
  };

  return (
    <div>
      <h3 className="mb-4 title">{clientId ? "Edit" : "Add"} Client</h3>
      <form onSubmit={formik.handleSubmit}>
        <div className="mt-4">
          <CustomInput
            type="text"
            label="Enter Sold Car"
            name="title"
            onChng={formik.handleChange("title")}
            onBlr={formik.handleBlur("title")}
            val={formik.values.title}
          />
          <div className="error">{formik.touched.title && formik.errors.title}</div>
        </div>

        <div className="bg-white border-1 p-5 text-center mt-3">
          <Dropzone onDrop={(acceptedFiles) => dispatch(uploadImg(acceptedFiles))}>
            {({ getRootProps, getInputProps }) => (
              <section>
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  <p>Drag & drop files here, or click to select</p>
                </div>
              </section>
            )}
          </Dropzone>
        </div>

        <div className="showimages client-images d-flex flex-wrap mt-3 gap-3">
          {formik.values.images.map((img, index) => (
            <div className="position-relative" key={index}>
              <button
                type="button"
                onClick={() => handleImageDelete(img.public_id)}
                className="btn-close position-absolute"
                style={{ top: "10px", right: "10px" }}
              ></button>
              <img src={img.url} alt="client-img" width={200} height={200} />
            </div>
          ))}
        </div>

        <button type="submit" className="btn btn-success border-0 rounded-3 my-5">
          {clientId ? "Edit" : "Add"} Client
        </button>
      </form>
    </div>
  );
};

export default AddClient;
